<template>
  <el-row class="dish">


    <el-row v-loading="loading_all_view">
      <el-row style="top:2px;float:right;position: absolute;right: 0;z-index: 1000">

        <el-button
          v-if="first_get_data"
          type="plain" size="mini"
          class="little-icon "
          icon="el-icon-s-home"
          @click="omnis_home"
          title="返回天览首页">
        </el-button>

        <!--<label style="color: white">请选择项目地</label>-->
        <!--<el-input v-if="project_conf.project_id != '-1' || project_conf.project_code != 'ALL'"-->
                  <!--v-model="project_conf.project_name" :disabled="true" id="project_input" style="width: 200px;"-->
                  <!--size="mini"></el-input>-->

        <!--<el-select v-else v-model="project_select" disabled placeholder="请选择项目名称" style="width: 200px;background-color: black"-->
                   <!--@change="change_project"-->
                   <!--size="mini" filterable id="project_selects" popper-class="project_select">-->
          <!--<el-option-->
            <!--style="background-color: black"-->
            <!--v-for="(item,index) in project_options"-->
            <!--:key="index"-->
            <!--:label="item.project_name"-->
            <!--:value="item.project_code">-->
          <!--</el-option>-->
        <!--</el-select>-->
        <project-select v-model="project_select" :dark="true" @change="change_project"></project-select>

        <el-button
          v-if="first_get_data"
          type="plain" size="mini"
          class="little-icon "
          icon="el-icon-omnis-zichan-wangluoshebei"
          @click="show_server"
          title="资产搜索">

        </el-button>

        <!--<el-button-->

          <!--v-if="first_get_data"-->
          <!--type="plain" size="mini"-->
          <!--class="little-icon "-->
          <!--icon="el-icon-omnis-guolv"-->
          <!--@click="open_filter"-->
          <!--title="高级过滤">-->
        <!--</el-button>-->

        <!--<el-button-->

          <!--type="plain" size="mini"-->
          <!--class="little-icon "-->
          <!--icon="el-icon-star-off"-->
          <!--v-if="this.show_focus == '1' &&first_get_data"-->
          <!--@click="show_panel_focus(1)"-->
          <!--title="显示关注">-->
        <!--</el-button>-->
        <!--<el-button-->
          <!--v-if=""-->
          <!--type="plain" size="mini"-->
          <!--class="little-icon "-->
          <!--style="margin-right: 8px"-->
          <!--icon="el-icon-star-on"-->
          <!--v-if="this.show_focus == '0'　&&first_get_data"-->
          <!--@click="show_panel_focus(0)"-->
          <!--title="显示全部">-->
        <!--</el-button>-->

        <el-button
          v-if="first_get_data"
          type="plain" size="mini"
          class="little-icon "
          style="margin-right: 8px"
          icon="el-icon-refresh-left"
          @click="reset_query"
          title="重置">
        </el-button>
      </el-row>
      <el-row :style="{background:'#161719',height:left_aside_height}">

        <el-tabs v-model="activeName"
                 type="card"
                 @tab-click="handleClick"
                 size="mini"
                 class="omnis"
                 style="z-index: 1"
        >
          <el-tab-pane v-for="(item,index) in panel_headers" :key="index" :name="item.name"
                       >
            <!--v-if="panel_data_auto(index).length !=0 || !is_ip_search"-->
            <span slot="label">

              <i :class="item.type_icon" v-if="item.type_icon" style="font-size: 12px"></i>
              <span class="panel_font">{{item.name}} </span>
              <icon_text :text="show_panel_length(item)"></icon_text>
            </span>
            <el-row style="display: flex;">
              <el-col :span="left_width">

                <el-row :style="left_close_class" class="left_aside" v-if="!left_open">
                  <el-button type="text" size="mini"
                             class="button-icon "
                             style="color: white;margin-left: 5px"
                             icon="el-icon-d-arrow-right"
                             title="打开"
                             @click="open_left(true)"></el-button>

                </el-row>
                <el-row style="padding-left: 2px;padding-top: 5px; margin-top: 5px; background: #161719"
                        v-if="left_open">
                  <el-row style="display: flex;margin-bottom: 2px;position: absolute;background: #161719">
                    <el-col :span="18" style="text-align: left;display: flex" class="search_input">
                      <el-button

                        type="plain" size="mini"
                        class="little-icon "
                        style="margin-left: 8px"
                        @click="show_link(index)"
                        icon="el-icon-omnis-lianjie"
                        v-if="!search_content &&first_get_data"
                        title="获取大屏连接">
                      </el-button>
                      <el-button
                        v-if="item.show_computer =='1' &&　!search_content &&first_get_data "
                        type="plain" size="mini"
                        class="little-icon "
                        style="margin-left: 8px"
                        @click="(e) => show_computer_info(e, index)"
                        icon="el-icon-s-platform"
                        title="查看资产信息">
                      </el-button>
                      <el-input v-model="host_binding_panel_form.search_content" style="margin-left: 5px;flex: 1" placeholder="搜索"
                                size="mini"></el-input>

                    </el-col>
                    <el-col :span="4">
                      <el-button
                        style="color: white;margin-left: 5px"
                        type="text"
                        size="mini"
                        icon="el-icon-d-arrow-left"
                        title="关闭"
                        @click="open_left(false)"
                      ></el-button>


                    </el-col>


                  </el-row>
                  <el-row :style="left_class" class="left_aside">
                    <!--<el-row style="text-align: left;overflow: hidden"-->
                            <!--v-for="(item,item_index) in panel_data_auto(index)"-->
                            <!--v-if="show_link_content(item,search_content[index])"-->
                            <!--:key="item_index">-->
                      <!--<div-->

                        <!--:class="{-->
                                  <!--link_active:(all_view_pannel[index] && all_view_pannel[index].indexOf(item.all_url)>=0) ,-->
                                   <!--link_title_active:(all_view_pannel_active[index] == item_index)-->
                          <!--}"-->
                        <!--class="panel_link_title text-hidden"-->
                        <!--:title="link_title(item.title,item.server_ip,item.server_name)"-->

                      <!--&gt;-->
                        <!--<div style="width: 85%;float: left" class="text-hidden item-text"-->
                             <!--@click="open_link(item.url,index,item_index,item)">-->
                          <!--<i :class="get_icon_class(item)"></i>-->


                          <!--<span>-->
                           <!--<span v-if="item.server_busi_name">{{item.server_busi_name}}-</span>-->
                            <!--<span v-if="item.server_name">{{item.server_name}}-</span>-->
                           <!--<span v-if="item.server_ip">{{item.server_ip}}-</span>-->
                        <!--</span>-->


                          <!--<span>{{item.title}}</span>-->

                        <!--</div>-->

                        <!--<i-->
                          <!--v-if="item.my_dashboard==0"-->
                          <!--class="el-icon-star-off icon-start"-->
                          <!--@click="focus_dashboard(item.dashboard_id)"-->
                          <!--title="关注"></i>-->

                        <!--<i-->
                          <!--v-if="item.my_dashboard==1"-->
                          <!--class="el-icon-star-on icon-start "-->
                          <!--@click="unfocus_dashboard(item.my_dashboard_id)"-->
                          <!--title="取消关注"></i>-->
                      <!--</div>-->

                    <!--</el-row>-->

                    <el-menu
                      :default-active="panel_default_active"
                      class="el-menu-vertical-demo monitor-screen-menu"
                      @open="{}"
                      @close="{}"
                      background-color="black"
                      text-color="#d8d8d8"
                      active-text-color="#ffd04b">
                      <template v-for="i in show_panel_data" v-if="item.name === activeName">

                        <el-submenu v-if="i.type === 'panel'" :index="i.id">
                          <template slot="title">
                            <i v-if="!i.type_icon" class="el-icon-menu"></i>
                            <ni-icon v-else size="mini" :icon="i.type_icon"></ni-icon>
                            <span :title="i.label">{{i.label}}</span>
                          </template>

                          <el-menu-item v-for="child in i.server_list"
                                        :index="child.id"
                                        :key="child.id" style="white-space:nowrap;text-overflow:ellipsis;overflow: hidden;"
                                        @click="to_monitor_page(child, i)">
                            <i v-if="!child.type_icon" class="el-icon-menu"></i>
                            <ni-icon v-else size="mini" :icon="child.type_icon"></ni-icon>
                            <span slot="title"  :title="child.label">{{child.label}}</span>
                          </el-menu-item>
                        </el-submenu>
                        <el-menu-item v-else :index="i.id"
                                      style="white-space:nowrap;text-overflow:ellipsis;overflow: hidden;"
                                      @click="to_monitor_page(i, item)">
                          <i v-if="!i.type_icon" class="el-icon-menu"></i>
                          <ni-icon v-else size="mini" :icon="i.type_icon"></ni-icon>
                          <span slot="title" :title="i.label">{{i.label}}</span>
                        </el-menu-item>
                      </template>

                    </el-menu>
                  </el-row>


                </el-row>
              </el-col>
              <el-col style="flex:1;background:#161719;margin-top: 5px">


                <iframe v-if="all_view_pannel[item.name] && all_view_pannel[item.name].url" :src="all_view_pannel[item.name].url" style="width: 100%;border-width:0px;"
                        :height="right_height">
                </iframe>


              </el-col>

            </el-row>

          </el-tab-pane>
        </el-tabs>

        <!--新增/修改/批量修改 资源页面-->
        <right_dialog :visiable.sync="assert_box_visiable" :before-close="before_close_asset_box" class="assert-manage-box">
          <template slot="body">
            <assert_manage ref="assert_manage" @handle_close="asset_box_show(false)"></assert_manage>
          </template>
        </right_dialog>
      </el-row>

    </el-row>

    <!-- 复制大屏链接到剪切板  开始-->
    <el-dialog
      class="big_link_show"
      title="大屏展示访问链接"
      :visible.sync="copy_url_dialog" width="45%"
      :close-on-click-modal="false"
    >
      <el-row style="margin-bottom: 5px">
        <el-col :span="20">
          <el-input size="mini" style="width: 95%" v-model="copy_monitoring_url"></el-input>
        </el-col>
        <el-col :span="2">
          <el-button size="mini" type="primary"
                     style="background-color: #289A45;color: #C1C2C3;border: none;padding-left: 20px"
                     v-clipboard="copy_monitoring_url"
                     @success="handleSuccess">复制
          </el-button>
        </el-col>
      </el-row>
      <span style="color: #FF9900;font-weight: bold;font-size: 15px">复制拷贝地址在浏览器中访问，按F11开启浏览器全屏模式即可完成大屏展示设定</span>
    </el-dialog>

    <el-dialog
      title="高级过滤"
      class="big_link_show"
      :visible.sync="filter_machine" width="45%"
      :close-on-click-modal="false"
    >
      <el-form :model="filter_form" style="color: #C1C2C3" size="mini" ref="filter_form" @submit.native.prevent>
        <el-form-item label="主机IP" :label-width="formLabelWidth" label-color="#C1C2C3">
          <el-autocomplete v-model="filter_form.server_ip" style="width: 90%" autocomplete="off" clearable
                           :fetch-suggestions="querySearchAsync"></el-autocomplete>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="filter_machine = false" style="background-color:#2B2B2D;color: #C1C2C3;border: #C1C2C3"
                   size="mini">取 消
        </el-button>
        <el-button type="primary" @click="query_filter()" style="background-color: #289A45;color: #C1C2C3;border: none"
                   size="mini">搜 索
        </el-button>
      </div>

    </el-dialog>
    <!-- 复制大屏链接到剪切板 结束-->

    <!-- 选择主机dialog  开始-->
    <el-dialog class="big_link_show" title="资源选择" :visible.sync="select_server_dialog" width="320px"
               :close-on-click-modal="false" top="5vh">
      <search_tree @item_click="item_server_click"
                   :show_information="false"
                   :has_toggle_btn="false"
                   content_height="-3"
                   show_computer
      ></search_tree>
      <span slot="footer" class="dialog-footer">
    <el-button @click="select_server_dialog = false" style="background-color:#2B2B2D;color: #C1C2C3;border: #C1C2C3"
               size="mini">取 消</el-button>
    <el-button type="primary" @click="select_server" style="background-color: #289A45;color: #C1C2C3;border: none"
               size="mini">选 择</el-button>
  </span>
    </el-dialog>


    <!-- 选择主机dialog 结束-->

  </el-row>
</template>

<script>
  import * as common from "@/common/index.js"
  import search_tree from "@/components/common_page/search_tree"
  import icon_text from "@/components/common_page/icon_text"
  import sys_code_select from "@/components/common_page/sys_code_select"
  import * as API from "@/api/index.js"
  import assert_manage from "@/components/common_page/assert_manage"
  import right_dialog from "@/components/common_page/right_dialog/index"
  import { NiIcon } from "@/ni-ui"
  import {ProjectSelect} from "@/omnis-business"

  export default {
    props: {
      first_get_data: {//是否初始化数据
        type: Boolean,
        default: true
      }
    },
    components: {
      search_tree,
      sys_code_select,
      icon_text,
      assert_manage,
      right_dialog,
      NiIcon,
      ProjectSelect,
    },
    comments: {},
    data() {
      return {
        is_ip_search: false,
        loading: false,
        zabbix_is_login: false,
        project_options: [],
        project_select: '',
        project_req_param: {
          "service": "project_manage.project",
          "disable_omnis_project": false
        },
        search_content: "",
        search_tree_server_id: "",
        host_binding_panel_form: {
          "server_id": "",
          server_ip: "",
          my_focus: "",
          search_content: "",
        },
        filter_form: {
          server_ip: ""
        },
        formLabelWidth: "80px",
        filter_machine: false,
        left_open: true,
        left_width: 3,
        right_width: 21,
        left_height: common.getTableHeight(-125) + "px",
        left_aside_height: common.getTableHeight(-55) + "px",
        left_close_height: common.getTableHeight(-75) + "px",
        right_height: common.getTableHeight(-91) + "px",
        all_view_panel_data: {
          "is_rel_server": 1,
        },
        application_panel_data: {
          "is_rel_server": 2,
        },
        all_view_data: [],
        application_data: [],
        all_view_pannel: {},//当前tab哪个激活，{activeName:{url: "https://g...", is_self: false }}     is_self ==> 是否为天览内部地址
        all_view_pannel_active: {},//当前页面标签激活，{"0":"1"},表示一个页面，第二个标签激活
        all_view_pannel_data: {},//当前tab哪个激活，{"0":"{server_id:1...}"}
        application_pannel: "",
        is_server: '',
        server_panel: '',
        activeName: '-1',
        copy_monitoring_url: '',
        copy_url_dialog: false, //复制大屏展示访问链接
        select_server_dialog: false, //选择主机dialog
        loading_all_view: false,

        panel_headers: [],
        panel_data: [],
        focus_form: {
          dashboard_id: "",
          my_dashboard_id: ""
        },
        dash_board_loading: {},
        show_focus: 1,
        first: true,
        // zabbix_session: "",
        project_conf: {
          project_id: "",
          project_code: "",
          project_name: "",
        },
        by_ops_console: false,
        assert_box_visiable: false,

        panel_req_param: {
          service: "dish.dish_type_query",
          show_server_list: true,
          project_code:"CBH"
        },

        rule_re: {
          "${agent_group}": "monitor_agent_group",
          "${agent_id}": "monitor_agent_id",
        },

        panel_default_active: "",

        grafana_domain: "http://192.168.20.163:9999",
        grafana_prefix_url: "/grafana_server",

        to_grafana: null,

        filter_panel_data: [],
        is_self_tag: "omnis_monitor",

        init_url_timeout: null,

        last_dish_type_param: {},   // 监控面板接口最后一次请求的参数


      }
    },
    computed: {

      show_panel_data(){
        // return function () {
          let search_content = "";
          let server_id = "";

          if (!this.panel_data[this.activeName]){
            return []
          }

          if (this.host_binding_panel_form.search_content){
            search_content = this.host_binding_panel_form.search_content;
          }
          if (this.host_binding_panel_form.server_id){
            server_id = this.host_binding_panel_form.server_id;
          }
          let arr = [];

          if (search_content || server_id){
            let temp_data = JSON.parse(JSON.stringify(this.panel_data[this.activeName]));
            temp_data.map(item => {
              if (item.type === 'panel'){
                let server_temp = item.server_list;
                if (server_id){
                  server_temp = server_temp.filter(i => i.server_id === server_id);
                  item.server_list = server_temp;
                }
                if (Array.isArray(item.server_list) && item.server_list.length > 0){
                  if (item.name.indexOf(search_content) > -1){
                    arr.push(item);
                  }else {
                    item.server_list = item.server_list.filter(i => this.filter_server_panel(i, search_content));
                    if (item.server_list.length > 0){
                      arr.push(item);
                    }
                  }
                }

              }else {

                if ((search_content && item.label.indexOf(search_content) > -1 ) || (server_id && item.server_id === server_id)){
                  arr.push(item);
                }
              }
            });

            this.filter_panel_data = arr;
            return this.filter_panel_data;
          }else {
            return this.panel_data[this.activeName];
          }

        // }
      },

      show_panel_length(){
        return function (row) {
          let server_count = 0, child_count = 0;
          if (Array.isArray(row.server_list)){
            server_count = row.server_list.length;
          }
          if(Array.isArray(row.children)){
            if (row.is_server_dish === '0'){
              child_count = row.children.length;
            }else {
              child_count = row.children.filter(item => item.is_server_dish === '1' && Array.isArray(item.server_list) && item.server_list.length > 0).length;
            }

          }
          return String(server_count + child_count);

        }
      },
      

      left_close_class() {
        return {
          "background": "#161719",

          "height": this.left_close_height
        }
      },

      left_class() {
        return {
          "text-align": "right",
          "background": "#161719",
          "margin-top": "30px",
          "overflow-y": "auto",
          "height": this.left_height,
          "overflow-x": "hidden",
        }
      },
      right_class() {
        return {
          "text-align": "right",
          "background": "#212124",
          "margin-top": "5px",

          "height": this.right_height
        }
      },


      application_url() {

        return window.$config.grafana_url + this.application_pannel + "?kiosk=tv"

      },


    },
    mounted() {
      this.grafana_domain = window.location.hostname === '127.0.0.1' || window.location.hostname === 'localhost' ? this.grafana_domain : '';
      this.get_panel_headers()
      let server_ip = getQueryString("server_ip")
      this.host_binding_panel_form.server_ip = server_ip
      if (this.first_get_data) {
        this.get_pannel_data()
      }

      this.getProjectsData()

    },
    methods: {

      set_init_page(child, parent){
          if (this.init_url_timeout){
            clearTimeout(this.init_url_timeout);
          }
          this.init_url_timeout = setTimeout(() =>{
            this.to_monitor_page(child, parent, (res) => {
              this.set_default_panel(res.id)
            });
            this.init_url_timeout = null;

          }, 800);
      },

      filter_server_panel(item, search_content){
        return (item.server_ip && item.server_ip.indexOf(search_content) > -1) || (item.monitor_agent_id && item.monitor_agent_id.indexOf(search_content) > -1);
      },

      set_default_panel_head(name){
        this.activeName = name;
      },

      set_default_panel(id){
        this.panel_default_active = id;
      },

      async to_monitor_page(row, parent, callback){
        this.all_view_pannel_data[this.activeName] = row
        let url = this.get_monitor_url(row, parent.grafana_url, parent.rule)
        if (url){
          if (this.is_zabbix(url) && row.rule !== this.is_self_tag) {
            await this.zabbix_login()
          }

          url = this.fix_protocol(url);

          this.all_view_pannel[this.activeName] = {
            url: url,
            is_self: row.rule === this.is_self_tag
          };
          this.$forceUpdate();

        }
        if (callback){
          callback(row)
        }


      },

      get_monitor_url(row, url, rule){
        let final_url = "";
        if (row.rule === this.is_self_tag){   // 天览内部地址
          if (!row.grafana_url){
            this.show_msg("请维护面板url", "error");
            return false;
          }
          final_url = row.grafana_url;

        }else {
          if (row.grafana_url) url = row.grafana_url;
          if (row.rule) rule = row.rule;
          if (!url || !rule) {
            this.show_msg("请维护面板url、rule", "error");
            return false;
          }
          for(var k in this.rule_re){
            let v = this.rule_re[k];
            if (rule.indexOf(k) > -1 && !row[v]) {
              this.show_msg(`请维护面板${v}`, "error");
              return false;
            }
            rule = rule.replace(k, row[v]);
          }
          if (rule.startsWith("&")){
            rule = "?" + rule.substring(1);
          }

          if(!url.startsWith("/")){
            url = "/" + url;
          }

          if (!url.startsWith(this.grafana_prefix_url)){
            url = this.grafana_prefix_url + url;
          }

          final_url = this.grafana_domain + url + rule;
          console.log(final_url)
        }

        return final_url;


      },

      // 关闭资源信息管理窗口前
      before_close_asset_box(done){
        this.$refs.assert_manage.box_all_close()
        done();
      },

      // 打开/关闭资源信息管理窗口
      asset_box_show(show){
        if(this.assert_box_visiable != show){
          this.assert_box_visiable = show
        }

      },

      omnis_home() {
        this.$router.push("/")
      },

      open_server(server_ip, project, project_conf) {

        for (let i = 0; i < this.panel_data.length; i++) {

          this.panel_data[i].splice(0, this.panel_data[i].length - 1)
        }
        this.host_binding_panel_form.server_ip = server_ip

        if (project_conf) {
          this.project_select = project_conf.project_code
          this.project_conf = project_conf
          this.by_ops_console = true

        } else {
          this.project_select = project
        }

        this.get_pannel_data()
      },

      // async zabbix_login() {
      //
      //   if (this.zabbix_is_login) {
      //     return
      //   }
      //   this.loading = true
      //   const response = await API.POST("/omnis/monitoring_center/monitoring_manage/zabbix_login")
      //   let data = response.data
      //
      //   if (data.success) {
      //     // const response = await API.GET(data.data)
      //     // let data = response.data
      //     if (data.success) {
      //       this.zabbix_session = data.data
      //     }
      //     this.zabbix_is_login = true
      //   }
      //   this.loading = false
      //
      //
      // },
      show_link_content(item, content) {


        if (!content) {
          return true
        }
        let title = item['title']
        let server_ip = item["server_ip"]
        let server_name = item["server_name"]
        let server_busi_name = item["server_busi_name"]
        if (title) {
          title = title.toLowerCase()
        } else {
          title = ""
        }
        if (server_ip) {
          server_ip = server_ip.toLowerCase()
        } else {
          server_ip = ""
        }

        if (server_name) {
          server_name = server_name.toLowerCase()
        } else {
          server_name = ""
        }

        if (server_busi_name) {
          server_busi_name = server_busi_name.toLowerCase()
        } else {
          server_busi_name = ""
        }


        content = content.toLowerCase()

        if (title.indexOf(content) >= 0 || server_ip.indexOf(content) >= 0 || server_name.indexOf(content) >= 0 || server_busi_name.indexOf(content) >= 0) {
          return true
        }
        return false
      },
      show_panel_focus(focus) {
        if (focus == 0) {
          this.show_focus = '1'
        } else {
          this.show_focus = '0'
        }

        this.host_binding_panel_form = {

          my_focus: focus,
        }
        this.get_pannel_data()
      },

      focus_dashboard(dashboard_id) {
        this.focus_form.dashboard_id = dashboard_id

        this.add_focus_dashboard()

      },
      async add_focus_dashboard() {
        this.loading_all_view = true
        const response = await API.POST("/omnis/monitoring_center/monitor_big_dish/my_focus_dashboard", this.focus_form)
        this.loading_all_view = false
        let data = response.data
        if (data.success) {
          this.get_pannel_data()
          this.$message.success(data.msg)
        }
      },

      unfocus_dashboard(my_dashboard_id) {
        this.focus_form.my_dashboard_id = my_dashboard_id

        this.remove_focus_dashboard()

      },

      async remove_focus_dashboard() {
        this.loading_all_view = true
        const response = await API.DELETE("/omnis/monitoring_center/monitor_big_dish/my_focus_dashboard", this.focus_form)
        this.loading_all_view = false
        let data = response.data
        if (data.success) {
          this.get_pannel_data()
          this.$message.success(data.msg)
        }
      },
      select_server() {
        if (!this.search_tree_server_id) {
          this.$message.warning("请选择资源！")
          return
        }
        this.host_binding_panel_form.server_id = this.search_tree_server_id;
        this.get_pannel_data()
        this.select_server_dialog = false
      },
      item_server_click(data) {
        if (data["id_type"] == 'server') {
          this.search_tree_server_id = data["id"]
        }


      },
      async querySearchAsync(queryString, cb) {
        let response = await API.GET("/omnis/monitoring_center/monitoring_init/base_fuzzy_get_ip", this.filter_form)
        let data = response.data
        if (data.success) {
          return cb(data.data)
        }

      },

      query_filter() {
        this.host_binding_panel_form = {
          server_ip: this.filter_form.server_ip

        }
        this.get_pannel_data()
        this.filter_machine = false
      },
      reset_query() {
        this.host_binding_panel_form = {
          server_id: "",
          server_ip: "",
          my_focus: "",
        },
          this.show_focus = 1
        this.get_panel_headers();
        this.all_view_pannel = {}//当前tab哪个激活，{"0":"https://g..."}
        this.all_view_pannel_active = {}//当前页面标签激活，{"0":"1"},表示一个页面，第二个标签激活
      },
      open_filter() {
        if (this.$refs.filter_form) {
          this.$refs.filter_form.resetFields()
        }
        this.filter_machine = true

      },
      get_icon_class(item) {
        let tags = item.tags
        if (!tags) {
          return "el-icon-omnis-jiankong-gailan"
        }
        tags = tags.toLowerCase()
        if (tags.indexOf("redis") >= 0) {
          return "el-icon-omnis-redis"
        } else if (tags.indexOf("jboss") >= 0) {
          return "el-icon-omnis-fuwuqi2"
        } else if (tags.indexOf("allview") >= 0) {
          return "el-icon-omnis-jiankong-gailan"
        } else if (tags.indexOf("application") >= 0) {
          return "el-icon-omnis-yewu"
        } else if (tags.indexOf("sqlserver") >= 0) {
          return "el-icon-omnis-sqlserver"
        } else if (tags.indexOf("esb") >= 0) {
          return "el-icon-omnis-tongxun_fuzhi"
        } else if (tags.indexOf("zookeeper") >= 0) {
          return "el-icon-omnis-zookeeper"
        } else if (tags.indexOf("report") >= 0) {
          return "el-icon-omnis-baogao"
        } else if (tags.indexOf("oracle") >= 0) {
          return "el-icon-omnis-oracle"
        }
      },
      link_title(title, ip, server_name) {
        let tmp = title
        if (ip) {
          tmp += "-" + ip
        }

        if (server_name) {
          tmp += "-" + server_name
        }
        return tmp
      },
      async get_pannel_data() {
        // this.loading_all_view = true
        // if (this.host_binding_panel_form.server_ip) {
        //   this.is_ip_search = true
        // } else {
        //   this.is_ip_search = false
        // }
        //
        // var datas = JSON.parse(JSON.stringify(this.host_binding_panel_form))
        // datas.sys_project_id = this.project_select
        // const response = await API.GET("/omnis/monitoring_center/monitoring_init/host_binding_panel_list", datas)
        // this.loading_all_view = false
        // let data = response.data
        // this.panel_data = data.data
        //
        // if (this.first) {//匹配第一个ip
        //   let server_ip = this.host_binding_panel_form.server_ip
        //   console.log(server_ip)
        //   this.activeName = ""
        //   if (server_ip) {
        //     for (let i = 0; i < this.panel_data.length; i++) {
        //       let list = this.panel_data[i]
        //       for (let j = 0; j < list.length; j++) {
        //         let item = list[j]
        //         if (item.server_ip == server_ip) {
        //
        //           this.open_link(item.url, i, j, item)
        //           this.activeName = this.panel_headers[i].name
        //           break
        //         }
        //
        //       }
        //       if (this.activeName) {
        //         break
        //       }
        //     }
        //
        //   }
        //
        //
        //   if (!this.activeName) {//没有匹配到主机，就匹配第一个
        //       for (let i = 0; i < this.panel_data.length; i++) {
        //         let list = this.panel_data[i]
        //         if (list.length > 0) {
        //           let j = 0
        //           let item = list[j]
        //           this.open_link(item.url, i, j, item)
        //           this.activeName = this.panel_headers[i].name
        //           break;
        //         }
        //
        //       }
        //     }
        //
        //
        // }


      },
      get_panel_headers() {

        let param = Object.assign({}, this.panel_req_param)
        param.project_code = this.project_select;
        this.last_dish_type_param = Object.assign({}, param);  // 记录最后一次请求的参数
        this.data_req(param, (data) =>{
          // 请求响应时间问题：需要从后端获取当前项目端，所以初始化时有两次请求，有时上一个请求比后一个请求时间长，导致后一个请求先响应，最终更新的是上一个请求的响应数据，所以根据请求参数进行判断
          if ( JSON.stringify(this.last_dish_type_param) === JSON.stringify(param) ){
            let default_head = data.data.find(item => item.is_default == "1")
            if(default_head){
              this.activeName = default_head.name
            }

            this.handle_panel_data(data.data);

            this.panel_headers = data.data;
          }
        })
      },

      handle_panel_data(data){
        let temp_arr = {};
        data.map((row, index) => {
          let temp_row = JSON.parse(JSON.stringify(row));
          let arr = [];

          if (Array.isArray(temp_row.server_list)){
            temp_row.server_list.map(item => {
              item.type = "monitor";
              item.label = item.monitor_agent_id ? item.monitor_agent_id : item.server_ip;;
            })
            arr = arr.concat(temp_row.server_list)
          }
          if(temp_row.children && Array.isArray(temp_row.children)){
            let children = []
            if (temp_row.is_server_dish === '0'){   // 非主机面板
              children = temp_row.children;
              children.map(i =>{
                i.type = "monitor";
                i.label = i.name;
              });
            }else {

              children = temp_row.children.filter(i => i.is_server_dish === '1' && Array.isArray(i.server_list) && i.server_list.length > 0)
              children.map(i => {
                i.type = "panel";
                i.label = i.name;
                i.server_list.map(j => {
                  j.type = "monitor";
                  j.label = j.monitor_agent_id ? j.monitor_agent_id : j.server_ip;
                });

              });
            }
            arr = arr.concat(children);
          }

          this.handle_init_data(arr, temp_row);
          temp_arr[row.name] = arr;

        })
        this.panel_data = temp_arr;
        console.log(this.panel_data)
      },

      handle_init_data(panel_data, panel_parent){
        if (panel_data.length > 0 && this.activeName === '-1'){
            this.set_default_panel_head(panel_parent.name);
          }
          if (panel_data.length > 0 && this.activeName === panel_parent.name) {
            let first = panel_data[0];
            let child = first.type === 'monitor' ? first : first.server_list[0];
            let parent = first.type === 'monitor' ? panel_parent : first;
            this.set_init_page(child, parent);
          }
      },


      // panel_data_auto(index) {
      //   if (this.panel_data[index]) {
      //     return this.panel_data[index]
      //   } else {
      //     return []
      //   }
      // },
      //
      // panel_length(index) {
      //   if (this.panel_data[index]) {
      //     return this.panel_data[index].length + ""
      //   } else {
      //     return "0"
      //   }
      // },
      open_left(val) {
        this.left_open = val
        if (this.left_open) {
          this.left_width = 3
          this.right_width = 21
          this.left_class.width = ""
        } else {
          this.left_width = 1
          this.right_width = 23
          this.left_class.width = "30px"
        }

      },
      handleSuccess(e) {

        this.$message.success(e.text + " 复制成功")
        this.copy_url_dialog = false
      },
      get_agent_url(tags, url_obj, url_orignal) {


        //取第一个类型

        let tags_arr = tags.split(",")
        // tag = tag.toLowerCase()
        let tag = ""
        let agent_types = window.$config.grafana_agent_append
        let arr = Object.keys(agent_types)
        let key = ""
        for (var i = 0; i < arr.length; i++) {//2个数组中查找第一个匹配的tag
          var item = arr[i]
          for (var j = 0; j < tags_arr.length; j++) {
            tag = tags_arr[j]
            tag = tag.toLowerCase()
            item = item.toLowerCase()
            if (item.indexOf(tag) >= 0) {
              key = item
              break
            }
          }
          if (key != "") {
            break
          }

        }

        tags_arr.remove("host")
        if (!key) {
          console.error({message: "没有配置类型:" + tags_arr.join(","), success: false})
        }
        var url = agent_types[key]
        if (!url) {
          url = ""
        }
        let url_addr = ""
        if (url.indexOf("${agent_group}") >= 0 || url.indexOf("${agent_id}") >= 0) {
          let monitor_agent_group = url_obj["monitor_agent_group"]
          let monitor_agent_id = url_obj["monitor_agent_id"]
          if (!monitor_agent_group || !monitor_agent_id) {
            return {message: " 请进入监控初始化监控探针", success: false}
          }
          url_addr = url.replace("${agent_group}", url_obj["monitor_agent_group"], monitor_agent_group).replace("${agent_id}", monitor_agent_id)
        } else {
          url_addr = url
        }
        if (url_orignal.startsWith("http") || this.is_zabbix(url_orignal)) {
          return {url: url_orignal, success: true}
        }
        let grafana_url = window.$config.grafana_url
        let protocol = window.location.protocol

        if (protocol == "https:") {//兼容iframe https
          if (!grafana_url.startsWith("https")) {
            grafana_url = grafana_url.replace("http", "https")
          }

        }
        url_addr = grafana_url + url_orignal + window.$config.grafana_append + url_addr
        return {url: url_addr, success: true}
      },
      fix_protocol(url) {
        let protocol = window.location.protocol
        if (protocol == "https:") {//兼容iframe https
          if (!url.startsWith("https")) {
            url = url.replace("http", "https")
          }

        }
        return url

      },

      async open_link(url, index, item_index, item) {
        if (this.is_zabbix(url)) {
          await this.zabbix_login()
        }

        let format_url = this.fix_protocol(item.final_url)
        if (item.error_info) {
          this.$message.warning(item.error_info)
          return
        }

        //路由组成，域名+绑定面板路由+固定拼接+类型动态拼接
        this.all_view_pannel[index] = format_url
        this.all_view_pannel_active[index] = item_index
        this.all_view_pannel_data[index] = item
        item.all_url = this.all_view_pannel[index]
        if (this.is_zabbix(url)) {
          this.all_view_pannel[index] += "&" + this.zabbix_session
          // this.all_view_pannel[index] = this.zabbix_session
        }
        console.log(this.all_view_pannel[index])
        this.$forceUpdate()
      },
      show_link(index) {
        let url = this.all_view_pannel[this.activeName].url;
        if (url.startsWith("/")){
          url = window.location.origin + url;
        }


        if (url) {//显示大屏链接，替换部分链接
          url = url.replace(window.$config.grafana_replace, window.$config.grafana_replace_to)
          this.copy_monitoring_url = url
        } else {
          this.copy_monitoring_url = ""
        }

        this.copy_url_dialog = true
      },

      show_computer_info(e, index) {
        let data = this.all_view_pannel_data[this.activeName]
        if (!data) {
          this.$message.warning("请选择资源")
          return
        }
        if (data["server_id"]) {
          this.asset_box_show(true)
          this.$refs.assert_manage.asset_information_search(data)
          e.stopPropagation()

        } else {
          this.$message.warning("没有主机")
        }

      },
      async all_view_panel_data_selected_data() {
        this.loading_all_view = true
        const response = await API.GET("/omnis/monitoring_center/monitoring_init/binding_none_server_pannel", this.all_view_panel_data)
        this.loading_all_view = false
        let data = response.data
        this.all_view_data = data.data
      },

      async application_panel_data_selected_data() {
        this.loading_all_view = true
        const response = await API.GET("/omnis/monitoring_center/monitoring_init/binding_none_server_pannel", this.application_panel_data)
        this.loading_all_view = false
        let data = response.data
        this.application_data = data.data
      },
      show_server() {
        this.select_server_dialog = true
      },
      handleClick(tab) {
        // debugger
        // if (tab== "all_view"){

        // }

      },
      item_click(tab) {

      },
      getProjectsData() {
        this.data_req(this.project_req_param, (data) =>{
          this.project_options = data.data;
          let default_project = data.data.find(item => item.default_project == "true");
          if (default_project){
            if(!this.project_select){
              this.project_select = default_project.project_code
            }
            if (!this.by_ops_console) {
              this.project_conf.project_id = default_project.sys_project_id
              this.project_conf.project_code = default_project.project_code
              this.project_conf.project_name = default_project.project_name
            }
          }
        })

      },

      change_project(item) {
        this.get_panel_headers()
      },


      async data_req(param, callback){
            this.loading_all_view = true
            let response = await API.POST("/omnis/template_data/data", param);
            this.loading_all_view = false
            let data = response.data
            if (data.success) {
              if(callback){
                callback(data);
              }

            }else {
              this.show_msg(data.msg, "error");
            }

        },

    }

  }
</script>

<style scoped>
  .right-box.assert-manage-box{
    top: 30px;
    height: calc(100% - 35px);
  }

  .item {
    margin-top: 10px;
    margin-right: 40px;
  }

  .panel_font {
    font-size: 12px;

  }

  .footer {

    height: 100px;

    width: 100%;

    background-color: #ddd;

    position: fixed;

    bottom: 0;

  }

  .text-hidden {
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .item-text {
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .panel_link_title {
    font-size: 12px;

    color: #d8d8d8 !important;
    background: #212124 !important;
    border: none;
    margin: 0.1rem 0.2rem;
    padding-left: 5px;
    border-radius: 2px;
    cursor: pointer;
    -webkit-box-shadow: -1px -1px 0 0 hsla(0, 0%, 100%, .1), 1px 1px 0 0 rgba(0, 0, 0, .3);
    box-shadow: -1px -1px 0 0 hsla(0, 0%, 100%, .1), 1px 1px 0 0 rgba(0, 0, 0, .3);

  }

  .panel_link_title:hover {
    color: #299C46 !important;
  }

  .link_active {
    color: white !important;
    background-color: #080808 !important;
  }

  .link_title_active {
    color: springgreen !important;
  }

  .button-icon {
    color: white;
  }

  .icon-start {
    float: right;
    width: 10%;
    padding-top: 7px;
    padding-bottom: 3px;
    padding-right: 4px;
  }

  .little-icon {
    color: #e8e8e8;
    font-size: 14px;
    background: #2D2D2F;
    border: none;
    padding: 4px 8px !important;
  }

  .little-icon:hover {
    color: white;
  }

  .el-button + .el-button {
    margin-left: 5px !important;
  }

  /*鼠标经过时的颜色*/
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background: #67676F;
  }

  /*下拉框数据颜色*/
  .el-select-dropdown__item {
    color: #C1C2C3;
    background: black !important;
  }

  /*选中行颜色*/
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    background-color: #67676F;
  }

  .el-dialog__title {
    color: white;
  }

</style>
<style>
  /*.el-popper.project_select .popper__arrow, .el-popper.project_select .popper__arrow::after {*/
    /*border-style: none;*/
  /*}*/

  /*.el-select-dropdown.el-popper.project_select {*/
    /*background: black !important;*/
    /*border: 1px solid #232F43 !important;*/
  /*}*/

  .big_link_show .el-tree {
    background: #242C2C;
    color: #C1C2C3;
  }

  .big_link_show .data_tree .el-tree-node__content > .el-tree-node__expand-icon {
    color: #C1C2C3;
  }

  .big_link_show .data_tree .el-tree-node__expand-icon.is-leaf {
    color: transparent;
  }

  .big_link_show .el-input--mini .el-input__inner {
    background: #242C2C;
    border: 1px solid #585252;
    color: #C1C2C3;
  }

  .big_link_show .el-form-item__label {
    color: #C1C2C3;
  }

  /*!*下拉框--input颜色*!*/
  /*#project_selects {*/
    /*color: #C1C2C3;*/
    /*background: #161719;*/
    /*border: 1px solid #232F43;*/
  /*}*/

  .big_link_show .el-dialog {
    background: #242C2C;
    border: 1px solid #40434B;
  }

  .big_link_show .el-dialog__title {
    color: #C1C2C3;
  }

  #project_input {
    background-color: #161719;
    border: 1px solid #232F43;
    color: #C1C2C3;
  }

</style>



// WEBPACK FOOTER //
// index.vue?1312cf10